var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewContactDataWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7812 2.8125C11.889 2.8125 11.9923 2.8553 12.0685 2.93149C12.1447 3.00767 12.1875 3.11101 12.1875 3.21875V10.5312C12.1875 10.639 12.1447 10.7423 12.0685 10.8185C11.9923 10.8947 11.889 10.9375 11.7812 10.9375H1.21875C1.11101 10.9375 1.00767 10.8947 0.931488 10.8185C0.855301 10.7423 0.8125 10.639 0.8125 10.5312V3.21875C0.8125 3.11101 0.855301 3.00767 0.931488 2.93149C1.00767 2.8553 1.11101 2.8125 1.21875 2.8125H11.7812ZM1.21875 2C0.895517 2 0.585524 2.1284 0.356964 2.35696C0.128404 2.58552 0 2.89552 0 3.21875L0 10.5312C0 10.8545 0.128404 11.1645 0.356964 11.393C0.585524 11.6216 0.895517 11.75 1.21875 11.75H11.7812C12.1045 11.75 12.4145 11.6216 12.643 11.393C12.8716 11.1645 13 10.8545 13 10.5312V3.21875C13 2.89552 12.8716 2.58552 12.643 2.35696C12.4145 2.1284 12.1045 2 11.7812 2H1.21875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4V6.5V9",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5H11",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewContactDataWhite);
export default __webpack_public_path__ + "static/media/new_contact_data_white.f9fed8f4068b47bc7e1559f91115ed32.svg";
export { ForwardRef as ReactComponent };